export const TOKEN_TYPE = {
  ERC20: 'ERC20',
  ERC721: 'ERC721',
  ERC1155: 'ERC1155',
};

export const PAYMENT_OPTION = {
  ETH: 'ETH',
  ZUT: 'ZUT',
};

export const ID_TO_NETWORK = {
  1: 'Mainnet',
  2: 'Morden',
  3: 'Ropsten',
  4: 'Rinkeby',
  5: 'Goerli',
  42: 'Kovan',
};

export const TOKEN_ADDRESSES = {
  ZUT: '0x83f873388cd14b83a9f47fabde3c9850b5c74548',
};

export const NFT_MULTISEND_ADDRESS = '0x38996fd29d0b3235d26ace30a6305bbdc6fc9caf';

export const ADMIN_ADDRESS = '0x4cE1a32A728c1C4cb2075eBEd3EfCfDc5e0959D4';
